var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedication(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 10,
    fill: "#F0F1EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_396_3434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0138 13.9158C15.2235 15.1729 16.3781 16.3729 17.5878 17.5729C16.818 18.43 16.2682 19.4015 16.0482 20.5443C15.9383 21.0586 15.9932 21.5729 15.8833 22.1443C15.8833 22.3158 15.7733 22.4872 15.6633 22.5443C13.0241 24.1443 9.50513 22.03 9.45015 18.8872C9.39516 17.5729 9.83504 16.43 10.7148 15.5158C12.4193 13.7443 14.0688 12.03 15.7733 10.2586C17.2579 8.71576 19.6222 8.54433 21.3267 9.91576C22.9762 11.23 23.4161 13.63 22.4264 15.5729C22.3164 15.8015 22.1514 15.9729 21.8215 15.9158C21.3817 15.8586 20.9968 15.9158 20.5569 15.9158C20.6119 15.8586 20.7219 15.7443 20.7768 15.63C21.9315 14.3729 21.9865 12.43 20.8318 11.23C19.6772 9.9729 17.8077 9.97291 16.5981 11.2872C15.7733 12.1443 14.9485 12.9443 14.0138 13.9158Z",
    fill: "#9CA37F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5872 24.9462C15.9377 23.1176 16.1576 19.8033 18.0271 17.9176C20.0615 15.8605 23.0306 16.1462 24.6251 17.5748C22.2608 20.0891 19.9515 22.5462 17.5872 24.9462Z",
    fill: "#9CA37F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4121 25.8558C20.7764 23.3986 23.0857 20.9986 25.4501 18.5415C26.7697 19.8558 27.1546 22.9986 25.3401 25.1701C23.4156 27.4558 20.2266 27.4558 18.4121 25.8558Z",
    fill: "#9CA37F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_396_3434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1,
    height: 18,
    fill: "white",
    transform: "translate(9.44995 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedication);
export default __webpack_public_path__ + "static/media/medication.93948ad6b563f9177940bf833d2e2143.svg";
export { ForwardRef as ReactComponent };